
import ORACLE_LOGO_SVG from './assets/images/oracle.svg';
import LOCAL_FILE_SVG  from './assets/images/local-file.svg';
import MARKATO_LOGO_SVG from './assets/images/marketo.svg';
import BRIGHTCOVE_LOGO from './assets/images/brightcove.svg';
import SALESFORCE_LOGO from './assets/images/salesforce.svg';
import CLOUDWORDS_GLOSSARY from './assets/images/cloudwords-glossary.svg';
import VIDYARD_LOGO from './assets/images/vidyard.svg';
import UBERFLIP_LOGO from "./assets/images/uberflip.svg";
import EXACTTARGET_LOGO from './assets/images/exacttarget-logo-2x.png'
import COUNTRY1 from "./assets/images/country1.svg";
import COUNTRY2 from "./assets/images/country2.svg";
import COUNTRY3 from "./assets/images/country3.svg";
import COUNTRY4 from "./assets/images/country4.svg";
import COUNTRY5 from "./assets/images/country5.svg";
import RESET_PASSWORD_SUCCESS from './assets/images/reset-password.svg';
import DEFAULT_VENDOR_LOGO from './assets/images/vendor-th.jpg';
import ELOQUA_EXTERNAL_VIEW_LOGO from './assets/images/eloqua-send-test.png';
import MARKETO_EXTERNAL_VIEW_LOGO from './assets/images/marketo-send-test-email.svg';

const  images = { 
       LOCAL_FILE_SVG,ORACLE_LOGO_SVG,MARKATO_LOGO_SVG,BRIGHTCOVE_LOGO,SALESFORCE_LOGO,
       CLOUDWORDS_GLOSSARY,VIDYARD_LOGO,EXACTTARGET_LOGO,UBERFLIP_LOGO,COUNTRY1,COUNTRY2,COUNTRY3,COUNTRY4,COUNTRY5,RESET_PASSWORD_SUCCESS,DEFAULT_VENDOR_LOGO,ELOQUA_EXTERNAL_VIEW_LOGO,
       MARKETO_EXTERNAL_VIEW_LOGO
}
export default images;

